import lottie from "lottie-web";
import { clearErrors } from "../module/errors";

// ✅ Импортируем JSON файлы напрямую
import loadingAnimation from "../../../public/animations/loading.json";
import successAnimation from "../../../public/animations/success.json";
import errorAnimation from "../../../public/animations/error.json";

let animation = null;

const animations = {
  // loading: `${window.assetUrl}/animations/loading.json`,
  // success: `${window.assetUrl}/animations/success.json`,
  // error: `${window.assetUrl}/animations/error.json`,

  loading: loadingAnimation,
  success: successAnimation,
  error: errorAnimation,
};

// export function showResultModal(type, text) {
//   const container = document.getElementById("result-lottie");
//   const textEl = document.getElementById("result-text");

//   textEl.textContent = text;
//   container.innerHTML = "";

//   if (animation) animation.destroy();

//   animation = lottie.loadAnimation({
//     container,
//     renderer: "svg",
//     loop: type === "loading",
//     autoplay: true,
//     path: animations[type],
//   });

//   MicroModal.show("modal-result");

//   const modalCloseBtnEl = document.getElementById("modal-response-close");
//   if (modalCloseBtnEl) {
//     if (type === "success") {
//       modalCloseBtnEl.style.display = "none";
//     } else if (type === "error") {
//       modalCloseBtnEl.style.display = "";
//     }
//   }

//   if (type === "success") {
//     setTimeout(() => {
//       MicroModal.close("modal-result");
//       MicroModal.close("modal-1");

//       const formEl = document.getElementById("index-form");
//       if (formEl && formEl.classList.contains("active")) {
//         formEl.reset();
//         clearErrors();
//       }
//     }, 2500);
//   }
// }

export function showResultModal(type, text) {
    const container = document.getElementById("result-lottie");
    const textEl = document.getElementById("result-text");

    if (!container) {
        console.error('Контейнер #result-lottie не найден');
        return;
    }

    textEl.textContent = text;
    container.innerHTML = "";

    // Уничтожаем старую анимацию
    if (animation) {
        animation.destroy();
        animation = null;
    }

    try {
        const animationData = animations[type];
        if (!animationData) {
            throw new Error(`Анимация для типа "${type}" не найдена`);
        }

        // ✅ Загружаем анимацию с использованием animationData
        animation = lottie.loadAnimation({
            container: container,
            renderer: 'svg',
            loop: type === 'loading',
            autoplay: true,
            animationData: animationData,
        });

        // Обработка ошибок
        animation.addEventListener('data_failed', (error) => {
            console.error('Ошибка загрузки анимации:', error);
            container.innerHTML = `<div style="padding: 40px; text-align: center; font-size: 48px;">${type === 'loading' ? '⏳' : type === 'success' ? '✅' : '❌'}</div>`;
        });

        // animation.addEventListener('loaded', () => {
        //     console.log(`Анимация ${type} успешно загружена`);
        // });

        // Показываем модальное окно
        MicroModal.show("modal-result");

        // Настройка кнопки закрытия
        const modalCloseBtnEl = document.getElementById("modal-response-close");
        if (modalCloseBtnEl) {
            if (type === "success") {
                modalCloseBtnEl.style.display = "none";
            } else if (type === "error") {
                modalCloseBtnEl.style.display = "";
            }
        }

        // Автоматическое закрытие для успешных операций
        if (type === "success") {
            setTimeout(() => {
                MicroModal.close("modal-result");
                MicroModal.close("modal-1");

                const formEl = document.getElementById("index-form");
                if (formEl && formEl.classList.contains("active")) {
                    formEl.reset();
                    clearErrors();
                }
            }, 2500);
        }

    } catch (error) {
        console.error('Ошибка при загрузке анимации:', error);
        // Заглушка при ошибке
        container.innerHTML = `<div style="padding: 40px; text-align: center; font-size: 48px;">${type === 'loading' ? '⏳' : type === 'success' ? '✅' : '❌'}</div>`;
        MicroModal.show("modal-result");
    }
}
